<template>
  <div :style="wrapStyle">
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <!-- 弹窗：个人信息-->
    <c-base-dialog v-model="isShow" :option="option" @close="isShow = false" @confirm="submit">
      <template slot="body">
        <div :class="getCss('modal')">
          <ul :class="getCss('list')">
            <li :class="getCss('list-item')">
              <span :class="getCss('list-item-label')">收件姓名：</span>
              <input
                type="text"
                v-model="name"
                :class="getCss('list-item-input')"
                :style="inputStyle"
              />
            </li>
            <li :class="getCss('list-item')">
              <span :class="getCss('list-item-label')">手机号：</span>
              <input
                type="text"
                v-model="phoneNum"
                :class="getCss('list-item-input')"
                :style="inputStyle"
              />
            </li>
            <li :class="getCss('list-item')">
              <span :class="getCss('list-item-label')">收货地址：</span>
              <input
                type="text"
                v-model="address"
                :class="getCss('list-item-input')"
                :style="inputStyle"
              />
            </li>
          </ul>
          <p :class="getCss('tip')" :style="{color: configurationData.tipsColor}">{{inputTrips}}</p>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CPopupAddress',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'popup-address-',
      isShow: false,
      address: '',
      phoneNum: '',
      name: '',
    };
  },
  computed: {
    option() {
      return Object.assign({}, this.dialogConfig, {
        header: '填写地址',
        fotter: true,
        confirm:this.dialogConfig?.confirmStyle?.backgroundImage ?  true : '确实',
        confirmStyle: Object.assign({}, this.dialogConfig?.confirmStyle?.backgroundImage ?
          this.dialogConfig?.confirmStyle  : {
          width: '2.6rem',
          background: this.dialogConfig?.dialogStyle?.color || '#3e3e3e',
        }),
        height: '6.5rem',
        width: '7.3rem',
        isConfirmClose: false,
        dialogStyle: Object.assign({}, this.dialogConfig?.dialogStyle || {}, {
          backgroundImage: this.configurationData.backgroundImage
            ? `url(${this.configurationData.backgroundImage})`
            : this.dialogConfig?.dialogStyle?.backgroundImage,
          color: this.dialogConfig?.dialogStyle?.color || '#3e3e3e',
        }),
      });
    },
    wrapStyle() {
      return {
        top: this.styles.base.top,
        left: this.styles.base.left,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    computedStyle() {
      return {
        backgroundImage: this.configurationData.btnImage ? `url(${this.configurationData.btnImage})` : 'none',
      };
    },
    inputTrips() {
      return this.configurationData.trips || '为保证正常发货，请正确填写手机号及收货地址';
    },
    inputStyle() {
      console.log('this.option.dialogStyle.color=', this.option?.dialogStyle?.color);

      return {
        borderRadius: '0.08rem',
        color: this.option?.dialogStyle?.color || '#3e3e3e',
        borderColor: this.option?.dialogStyle?.color || '#3e3e3e',
        background: this.configurationData.inputBackgroundColor || '#ffffff',
      };
    },
  },
  mounted() {
    console.log('version:1.0.18 configurationData===========popaddress=', this.configurationData, this.option);
    // if (!this.configurationData.bindFlowID || !this.configurationData.checkFlowID) {
    //   return false;
    // }
    this.initialize();
  },
  methods: {
    initialize() {
      this.$refs.button.setClickHandler(this.showDialog, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
      });

      const self = this;
      // 监听user.ready
      this.$onLogined(async () => {
        self.check();
      });

      // 监听package.address.fill
      this.$eventBus.$on('ceiba:common:events:address-fill', () => {
        self.showDialog();
      });
    },
    async showDialog() {
      console.log('this.isShow=true');
      this.isShow = true;
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
    },
    closeDialog() {
      this.isShow = false;
    },
    async check() {
      console.log('this.configurationData.checkFlowID=', this.configurationData, this.configurationData.checkFlowID);
      const response = await this.flowRequest({
        flowId: this.configurationData.checkFlowID,
      });
      const { ret, msg, data } = response;
      if (ret !== 0) {
        this.alert(msg);
        return false;
      }
      data.ret = parseInt(data.ret, 10);
      if (data.ret === 0) {
        (this.address = data.addr.Address), (this.phoneNum = data.addr.Phone), (this.name = data.addr.Name);
      } else {
        this.alert('查询绑定地址失败:', response.msg);
      }
    },
    async submit() {
      console.log(this.phoneNum, this.address, this.name);
      if (!this.address) {
        this.alert('请正确输入地址');
        return false;
      }
      if (!this.phoneNum) {
        this.alert('手机号码不能为空');
        return false;
      }
      if (isNaN(this.phoneNum) || this.phoneNum.indexOf('.') >= 0) {
        this.alert('手机号码必须为数字。');
        return false;
      }
      if (this.phoneNum.length !== 11) {
        this.alert('手机号码长度不正确');
        return false;
      }
      if (!/^1[3|4|5|6|7|8][0-9]\d{4,8}$/.test(this.phoneNum)) {
        this.alert('请填写正确的手机号码。');
        return false;
      }
      if (!this.name) {
        this.alert('请正确输入姓名');
        return false;
      }
      const params = JSON.stringify({ address: this.address, phoneNum: this.phoneNum, name: this.name });
      console.log('bind params=', params);
      const response = await this.flowRequest({
        flowId: this.configurationData.bindFlowID,
        params: {
          data: params,
        },
      });
      const { data } = response;
      data.ret = parseInt(data.ret, 10);
      if (data.ret === 0) {
        this.alert('提交成功');
        this.closeDialog();
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_address',
          eventData: {
            status: '1',
          },
        });
      } else {
        this.alert(response.msg);
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_address',
          eventData: {
            status: '0',
          },
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
